(function () {
  'use strict';

  /* The Pareto PDP has one dedicated purchase controller. Loading the legacy
     global ATC enhancer there duplicated work and rewrote the same controls. */
  if (document.body && document.body.classList.contains('template-product')) return;

  var current = document.currentScript;
  if (!current || !current.src) return;

  var legacy = document.createElement('script');
  legacy.src = current.src.replace('noody-atc-ux.js', 'noody-atc-ux-legacy.js');
  legacy.async = false;
  document.head.appendChild(legacy);
})();
